import React, { useEffect } from "react";
import { UserAnalytics } from "../../components/analyticsTable/userAnalytics";
import DefaultHeading from '../../components/heading/DefaultHeading';
import { eventEnum, logEvent } from "../../services/eventsService/eventService";
import { OrderAnalytics } from "../../features/orderAnalytics/orderAnalytics";
import './userAnalytics.css'
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";
export function Analytics() {
    const { translate } = usePortalTranslation();
    useEffect(() => {
        logEvent(eventEnum.live_dashboard, { feature_name: "Analytics" })
    }, [])
    return (
        <div className="box-container">
            <div className="tile-container">
                <DefaultHeading heading= {translate(TranslationEnum.analytics,"User Analytics")} />
                <UserAnalytics />
                <DefaultHeading heading={translate(TranslationEnum.analytics,"Order Analytics")} />
                <OrderAnalytics />
            </div>
        </div>
    );
}